// Stimulus controllers are registered manually (esbuild build, no autoloading).
import { application } from "./application"

import SubmitOnEnterController from "./submit_on_enter_controller"
application.register("submit-on-enter", SubmitOnEnterController)

import DndController from "./dnd_controller"
application.register("dnd", DndController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import ComposerController from "./composer_controller"
application.register("composer", ComposerController)

import BlindActivityController from "./blind_activity_controller"
application.register("blind-activity", BlindActivityController)

import EditableController from "./editable_controller"
application.register("editable", EditableController)

import PresenceController from "./presence_controller"
application.register("presence", PresenceController)
